import React from "react";

const OwnerVerification = ({ ssr }) => {
  return (
    <iframe
      className="w-full h-screen"
      src={`https://esign.natsisa.com/${ssr.result?.hash}?Domain=${ssr.result?.domain}`}
    ></iframe>
  );
};

export default OwnerVerification;
